import { StatAlerts } from 'app/model/redshift/stat-alerts';
import { RestfulApiService } from 'app/services/restful-api.service';

class StatAlertsService extends RestfulApiService<StatAlerts> {
    public updateStatus<StatAlerts>(id: number, status: number) {
        const url = this.getAbsolutePath(this.getPath());

        return this.http.patch<StatAlerts>(`${url}/${id}`, { status }).subscribe((newAlert) => {
            return newAlert;
        });
    }

    protected getFormName(): string {
        return 'stat-alerts';
    }

    protected getPath(): string {
        return 'qa/stat-alerts';
    }
}

export const statAlertsService = new StatAlertsService();
